import { fixString } from "@monta/router-js";
import { LoginResultType, RegistrationStateIdEnum } from "./enums";
import { ServerLogger } from "./logger";
import Toast from "./toast";

import type { AxiosError } from "axios";
import type { TToastOptions } from "@monta/design-system";
import type { ENV } from "@monta/env";
import type { NextPageContext } from "next";
import type { Auth } from "./auth";
import type { TAuthErrorResponse } from "./types";

const toastOptions: TToastOptions = {
  message: "",
  timeout: 4000,
  position: "bottom-right"
};

export const loginErrorHandler = (e: AxiosError<TAuthErrorResponse>) => {
  ServerLogger.error(String(e.message));

  if (!e.response?.data?.message) return Promise.reject(e);

  const message = e.response?.data?.message;
  let status = true;

  switch (message) {
    case LoginResultType.NOT_REGISTERED:
      toastOptions["message"] =
        "این نام کاربری تاکنون در منتا ثبت نام نشده است.";
      Toast?.error(toastOptions);
      status = false;
      break;

    case LoginResultType.AlreadyLoggedIn:
      toastOptions["message"] =
        "به نظر می رسد شما در حال حاضر، با مرورگر دیگری وارد سایت شده‌اید.";
      Toast?.error(toastOptions);

      break;
    case LoginResultType.Banned:
      toastOptions["message"] = "حساب کاربری شما به طور موقت بسته شده است.";
      Toast?.error(toastOptions);

      status = false;
      break;
    case LoginResultType.CaptchaChallengeFailed:
      break;
    case LoginResultType.GRADE_IDS_NULL_IN_FINAL_REGISTRATION:
      toastOptions["message"] =
        "پایه تحصیلی خود را در فرم ثبت نام انتخاب کنید.";
      Toast?.error(toastOptions);
      break;
    case LoginResultType.HasOpenExam:
      toastOptions["message"] = "آزمون ناتمام دارید.";
      Toast?.error(toastOptions);

      break;
    case LoginResultType.INVALID_VERIFICATION_CODE:
      toastOptions["message"] = "کد تایید نامعتبر است";
      Toast?.error(toastOptions);

      status = false;
      break;
    case LoginResultType.InvalidUserName:
    case LoginResultType.InvalidUserNamePassword:
      toastOptions["message"] = "نام کاربری یا رمز عبور اشتباه است.";
      Toast?.error(toastOptions);

      status = false;
      break;
    case LoginResultType.LoggedInAnotherTab:
      toastOptions["message"] =
        "شما در Tab دیگری فعال هستید لطفا از همان Tab استغاده کنید.";
      Toast?.error(toastOptions);

      status = false;
      break;
    case LoginResultType.MAJOR_IDS_NULL_IN_FINAL_REGISTRATION:
      toastOptions["message"] =
        "رشته تحصیلی خود را در فرم ثبت نام انتخاب کنید.";
      Toast?.error(toastOptions);

      break;
    case LoginResultType.Ok:
      break;
    case LoginResultType.OldVersion:
      break;
    case LoginResultType.Unknown:
      toastOptions["message"] = "یک جای کار ایراد دارد!";
      Toast?.error(toastOptions);

      status = false;
      break;
    case LoginResultType.SuspendContract:
      const paymentLinkId = e.response?.data?.details[0].paymentLinkId;
      const userId = e.response?.data?.details[0].userId;
      redirect(
        `/prefactor/${userId}/${paymentLinkId}?suspend=true`,
        "LANDING_URL"
      );
      status = false;
      break;
    case LoginResultType.BlockedUser:
      toastOptions["message"] = "دسترسی کاربر محدود شده است.";
      Toast?.error(toastOptions);

      status = false;
      break;
    default:
      break;
  }

  if (status) return true;

  return Promise.reject(e);
};

export const redirect = (
  url: string,
  project: keyof ENV,
  ctx?: NextPageContext
) => {
  const location = fixString(url, project);
  // @ts-expect-error noUtilsRedirect is not defined
  if (ctx?.res && !ctx.res?.noUtilsRedirect) return;

  if (ctx) ctx.res?.writeHead(307, undefined, { location });
  else Object.assign(window.location, { href: location });
};

export const checkRegister = (
  auth: Auth,
  registrationStateId: number,
  ctx?: NextPageContext
) => {
  const completionUrl = "/auth/register/completion";
  const currentURL = typeof window !== "undefined" && window.location.pathname;

  if (
    registrationStateId === RegistrationStateIdEnum.INITIALIZED &&
    currentURL !== completionUrl
  ) {
    redirect(
      `${completionUrl}?user-type-id=${auth.user?.subTypeId}&is-partial=true&data-completion=true`,
      "APPLICATION_URL",
      ctx
    );
    return false;
  }
  return true;
};
